import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/Header';
import HeroSection from './components/HeroSection';
import FeaturesGrid from './components/FeaturesGrid';
import WorkflowDemo from './components/WorkflowDemo';
import CaseStudiesSection from './components/CaseStudiesSection';
import ROICalculator from './components/ROICalculator';
import TemplatesSection from './components/TemplatesSection';
import IntegrationsSection from './components/IntegrationsSection';
import CTASection from './components/CTASection';
import Footer from '../../components/Footer';

const WhatsAppEmailAutomation = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'WhatsApp & Email Automation | Make Mind Automations';
  }, []);

  return (
    <>
      <Helmet>
  {/* Primary SEO */}
  <title>WhatsApp & Email Automation Workflows | Make Mind Automations</title>
  <meta
    name="description"
    content="Turn every lead into a conversation with automated WhatsApp and email follow-up workflows. We build Make.com and n8n automations that send instant replies, nurture leads, and recover lost deals on autopilot."
  />
  <meta
    name="keywords"
    content="WhatsApp automation, email automation, follow-up automation, lead nurturing, n8n workflows, Make.com automation agency"
  />
  <link
    rel="canonical"
    href="https://www.makemindautomations.tech/whats-app-email-automation"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="WhatsApp & Email Automation Workflows | Make Mind Automations"
  />
  <meta
    property="og:description"
    content="Instant replies, smart follow-ups, and recovery campaigns for your leads via WhatsApp and email."
  />
  <meta
    property="og:url"
    content="https://www.makemindautomations.tech/whats-app-email-automation"
  />
  <meta
    property="og:image"
    content="https://www.makemindautomations.tech/og-image.jpg"
  />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta
    name="twitter:title"
    content="WhatsApp & Email Automation Workflows | Make Mind Automations"
  />
  <meta
    name="twitter:description"
    content="Done-for-you WhatsApp and email automation sequences that close more deals on autopilot."
  />
  <meta
    name="twitter:image"
    content="https://www.makemindautomations.tech/og-image.jpg"
  />
</Helmet>


      <div className="min-h-screen bg-background">
        <Header />
        <main>
          <HeroSection />
          <FeaturesGrid />
          <WorkflowDemo />
          <CaseStudiesSection />
          <ROICalculator />
          <TemplatesSection />
          <IntegrationsSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default WhatsAppEmailAutomation;